export default {
      id: "accountability-usage",
      viewBox: "0 0 92 100",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#accountability",
      toString: function () {
        return this.url;
      }
    }